import { Box, Group, Button, ActionIcon, useMantineColorScheme } from "@mantine/core";
import { Play } from "lucide-react";
import { VariableInput } from "./VariableInput";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
    setVariableValues,
    selectReportFull
} from "@/store/slices/reportSlice";

interface ReportVariablesBarProps {
    onRun: (values: Record<string, string>) => void;
}

export function ReportVariablesBar({ onRun }: ReportVariablesBarProps) {
    const dispatch = useAppDispatch();
    const {
        report,
        requiredVariables,
        variableValues,
        isExecuting
    } = useAppSelector(selectReportFull);

    const { colorScheme } = useMantineColorScheme();
    if (!report || requiredVariables.length === 0) return null;

    return (
        <Box
            p={{ base: 'xs', sm: 'md' }}
            style={{
                backgroundColor: colorScheme === 'dark' ? 'rgba(255, 255, 255, 0.01)' : undefined,
                borderRadius: 'var(--mantine-radius-md)',
                border: '1px solid var(--modal-border)'
            }}
        >
            <Group align="flex-end" gap="xs">
                {requiredVariables.map(varName => (
                    <VariableInput
                        key={varName}
                        name={varName}
                        config={(report.variables || []).find(v => v.name === varName)}
                        value={variableValues[varName] || ""}
                        onChange={(val) => dispatch(setVariableValues({ ...variableValues, [varName]: val }))}
                        dataSourceId={report.dataSourceId}
                    />
                ))}
                <Button
                    visibleFrom="sm"
                    leftSection={<Play size={16} />}
                    onClick={() => onRun(variableValues)}
                    loading={isExecuting}
                    variant="filled"
                    color={colorScheme === 'dark' ? 'gray.8' : 'brand'}
                >
                    Run Report
                </Button>
                <ActionIcon
                    hiddenFrom="sm"
                    size="lg"
                    variant="filled"
                    onClick={() => onRun(variableValues)}
                    loading={isExecuting}
                    color={colorScheme === 'dark' ? 'gray.8' : 'brand'}
                >
                    <Play size={20} />
                </ActionIcon>
            </Group>
        </Box>
    );
}
